import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { catchError } from "rxjs/operators";
@Injectable()

export class AuthInterceptor implements HttpInterceptor {
	constructor(private router: Router) {} 
   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {  
	let token ='';
	if (localStorage.getItem("UserData") != null) {

		let data = JSON.parse(localStorage.getItem("UserData"));

		 token = data.token;


	} else {
		 token = "";
	}

	//   const token = this.authService.getAuthToken();
  
	 if (token) {
	   // If we have a token, we set it to the header
	//    request = request.clone({
	// 	  setHeaders: {Authorization: `Authorization token ${token}`}
	//    });

	    request = request.clone({
		headers: request.headers.set("Authorization", "Bearer " + token)
	});
	}
  
	return next.handle(request).pipe(
		catchError((err) => {
		  if (err instanceof HttpErrorResponse) {
			  if (err.status === 401) {
				localStorage.clear();
				this.router.navigate(["/signin"]);
		   }
		}
		return throwError(err);
	  })
	 )
	}
  }
  

